var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgError(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 65,
    viewBox: "0 0 66 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.501953,
    y: 0.758789,
    width: 65,
    height: 65,
    rx: 32.4668,
    fill: "#E41861"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.1206 28.1954C40.7064 27.6096 40.7064 26.6599 40.1206 26.0741C39.5348 25.4883 38.5851 25.4883 37.9993 26.0741L32.9691 31.1043L27.9396 26.0747C27.3538 25.4889 26.404 25.4889 25.8182 26.0747C25.2325 26.6605 25.2325 27.6103 25.8182 28.196L30.8478 33.2256L25.8182 38.2551C25.2325 38.8409 25.2325 39.7907 25.8182 40.3764C26.404 40.9622 27.3538 40.9622 27.9396 40.3764L32.9691 35.3469L37.9993 40.3771C38.5851 40.9629 39.5348 40.9629 40.1206 40.3771C40.7064 39.7913 40.7064 38.8415 40.1206 38.2557L35.0904 33.2256L40.1206 28.1954Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/error.36b998e56cabc0cf78ee6af95f2519c1.svg";
export { ForwardRef as ReactComponent };